// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hzHV8","canvas":"style_canvas__xeiyt","button":"style_button__nfJeN"};